import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'hooks';
import { PATHS } from 'routes/routePaths';
import LoadingScreen from 'components/feedback/LoadingScreen';

/**
 * Role-based gate. Compose *inside* ProtectedRoute — this assumes a user
 * already exists and only checks whether their role is permitted.
 *
 * Usage:
 *   <Route element={<ProtectedRoute />}>
 *     <Route element={<RoleRoute allow={[ROLES.MENTOR]} />}>
 *       <Route path="/mentor/dashboard" element={<MentorDashboard />} />
 *     </Route>
 *   </Route>
 */
export default function RoleRoute({ allow = [] }) {
  const { user, role, isLoading } = useAuth();

  if (isLoading) return <LoadingScreen />;

  // Should be wrapped by ProtectedRoute, but stay defensive.
  if (!user) return <Navigate to={PATHS.LOGIN} replace />;

  if (!allow.includes(role)) {
    return <Navigate to={PATHS.UNAUTHORIZED} replace />;
  }

  return <Outlet />;
}
